import { ref } from "vue";
import { trackTab } from "@/analytics/drawing-analytics";

/**
 * Modale Affichage de l'outil dessin (montée une fois, cf. CanvasLayout),
 * ouverte depuis le menu fichier, le bas des réglages ou la présentation
 * « L'interface évolue ».
 */
export const isDisplayDialogOpen = ref(false);

const OPENED_FROM = {
  file_menu: "display_opened_from_file_menu",
  settings: "display_opened_from_settings",
  ui_changes: "display_opened_from_ui_changes",
} as const;

export function openDisplayDialog(source: keyof typeof OPENED_FROM) {
  isDisplayDialogOpen.value = true;
  trackTab("settings", OPENED_FROM[source]);
}
